import type { Operation } from '../../../model/extension/types.tsx';
import type { State } from '../../types.tsx';

export const operationsSelector = (state: State): Operation[] => state.config.extension.operations;
